import { defineStore } from 'pinia';
import { useApi } from '@/composables/useApi';
import { ref, computed } from 'vue';

export default defineStore('config', () => {
	const config = ref(null);

	const onyxFullVisibility = computed(() => {
		return config.value?.onyx_full_visibility;
	});
	const domainTransactionsEnabled = computed(() => {
		return config.value?.domain_transactions_enabled;
	});
	const editorMessage = computed(() => {
		return config.value?.editor_message;
	});
	const demoDomains = computed(() => {
		return [...(config.value?.demo_domains ?? [])]?.sort();
	});
	const demoUsers = computed(() => {
		return config.value?.demo_users ?? [];
	});
	const demoAgent = computed(() => {
		return config.value?.demo_agent ?? {};
	});

	function isDemoAgentID(agentID) {
		if (agentID === null || agentID === undefined) {
			return false;
		}
		const muidMatch = agentID === demoAgent.value.muid;
		const aidMatch = agentID === demoAgent.value.associate_id;
		return muidMatch || aidMatch;
	}

	async function getSiteConfig() {
		config.value = null;
		const result = await useApi('api/site_config/', {
			message: 'there was an issue retrieving site settings! Please try again later.',
		}).json();

		config.value = result?.data?.value;

		return Promise.resolve();
	}
	async function saveSiteConfig({ config }) {
		await useApi('api/site_config/', {
			message: 'there was an issue saving site settings! Please try again later.',
		}).post({ ...config });

		await getSiteConfig();
		return Promise.resolve();
	}
	async function ensureSiteConfig() {
		if (!config.value) {
			await getSiteConfig();
		}
	}

	return {
		config,
		onyxFullVisibility,
		domainTransactionsEnabled,
		editorMessage,
		demoDomains,
		demoUsers,
		demoAgent,

		isDemoAgentID,
		getSiteConfig,
		ensureSiteConfig,
		saveSiteConfig,
	};
});
